module.exports = __webpack_public_path__ + "static/media/80.fee76e39.webp";